import React, { FC } from 'react';
import Image from 'next/image';
import Link from 'next/link';
import { useRouter } from 'next/router';
import styles from './Logo.module.scss';
import logoShab from '@/public/images/logo-shab.svg';
import logoShabDark from '@/public/images/logo-shab-dark.svg';
interface Props {
  isLightMode: boolean;
}
const Logo: FC<Props> = ({
  isLightMode
}) => {
  const router = useRouter();
  return <Link href={'/'} passHref className={styles['logo']} onClick={e => router.asPath === '/' && e.preventDefault()} data-sentry-element="Link" data-sentry-component="Logo" data-sentry-source-file="Logo.tsx">
      <Image src={isLightMode ? logoShab : logoShabDark} alt="سایت شب" data-sentry-element="Image" data-sentry-source-file="Logo.tsx" />
    </Link>;
};
export default Logo;